import { render, staticRenderFns } from "./PStatements.vue?vue&type=template&id=c12a1a62"
import script from "./PStatements.vue?vue&type=script&lang=js"
export * from "./PStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports